import { maybe } from "@saleor/misc";

export const hasBrgyStreetAddr = order =>
  maybe(() => order.shippingAddress.unitDetails) !== null ||
  maybe(() => order.shippingAddress.streetBrgy) !== null;

export const addressLineOne = order => {
  const unitDetails = order?.shippingAddress?.unitDetails;
  if (order?.shippingAddress && hasBrgyStreetAddr(order)) {
    if (unitDetails === null || unitDetails === "") {
      return (
        `${order?.shippingAddress?.streetAddress2},` +
        " " +
        order?.shippingAddress?.streetBrgy
      );
    } else {
      return (
        `${order?.shippingAddress?.unitDetails},` +
        " " +
        `${order?.shippingAddress?.streetAddress2},` +
        " " +
        order?.shippingAddress?.streetBrgy
      );
    }
  } else {
    return "";
  }
};

export const addressLineTwo = order => {
  if (order?.shippingAddress) {
    return (
      `${order?.shippingAddress?.streetAddress1},` +
      " " +
      order?.shippingAddress?.postalCode
    );
  } else {
    return "";
  }
};

export const addressLineThree = order => {
  const shippingAddress = order?.shippingAddress;
  if (shippingAddress) {
    if (
      (shippingAddress?.landmark === "" ||
        shippingAddress?.landmark === null) &&
      (shippingAddress?.provinceName === "" ||
        shippingAddress?.provinceName === null)
    ) {
      return shippingAddress?.city;
    } else if (
      shippingAddress?.provinceName === "" ||
      shippingAddress?.provinceName === null
    ) {
      return `${shippingAddress?.landmark},` + " " + shippingAddress?.city;
    } else if (
      shippingAddress?.landmark === "" ||
      shippingAddress?.landmark === null
    ) {
      return `${shippingAddress?.city},` + " " + shippingAddress?.provinceName;
    } else {
      return (
        `${shippingAddress?.landmark},` +
        " " +
        `${shippingAddress?.city},` +
        " " +
        shippingAddress?.provinceName
      );
    }
  } else {
    return "";
  }
};

export const addressLineFour = order => {
  const shippingAddress = order?.shippingAddress;
  if (shippingAddress) {
    if (
      shippingAddress?.provinceName === "" ||
      shippingAddress?.provinceName === null
    ) {
      return shippingAddress?.city;
    } else {
      return `${shippingAddress?.city},` + " " + shippingAddress?.provinceName;
    }
  } else {
    return "";
  }
};
